// src/app/features/payments/checkout/components/orderSummarySection/OrderSummarySection.tsx
import { motion } from "motion/react";
import { Package } from "lucide-react";
import type { CheckoutLocationState } from "@/app/core/TokensPayment/checkOutComp/subscribe/shared/checkoutTypes";
import { useTranslation } from "@/app/core/ui/theme/LanguageProvider";

interface OrderSummarySectionProps {
  product: CheckoutLocationState;
  formattedSubtotal: string;
}

export function OrderSummarySection({ product, formattedSubtotal }: OrderSummarySectionProps) {
  const { t } = useTranslation();

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="mb-6 rounded-2xl border border-white/30 dark:border-white/20 bg-white/10 dark:bg-white/5 backdrop-blur-md p-6 shadow-lg"
    >
      <div className="flex items-center gap-3 mb-4">
        <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-violet-600/20">
          <Package className="h-5 w-5 text-violet-600" />
        </div>
        <h2 className="text-sm font-semibold uppercase tracking-wide text-muted-foreground">{t('yourOrder')}</h2>
      </div>
      <div className="mb-4 text-xl font-bold text-foreground">{product.productName}</div>
      <div className="text-3xl font-bold text-violet-600">{formattedSubtotal}</div>
    </motion.div>
  );
}